export enum TrialRestaurantActivity {
  CreatedFirstRecipe = 1,
  TriedAddingIngredientToFirstRecipe = 2,
  GeneratedFirstLabel = 3,
  DownloadedFirstLabel = 4,
  BookedFreeFifteenMinuteDemo = 5,
  ViewedTrainingVideo = 6
}
